// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "._306b17,._531b55{gap:.75em;display:inline-flex;align-items:center;justify-content:center}._306b17{visibility:hidden;margin:0 -1em}._531b55{position:absolute;top:0;right:0;bottom:0;left:0}.a418a6{opacity:.25 !important}", ""]);
// Exports
exports.locals = {
	"placeholder": "_306b17",
	"label": "_531b55",
	"disabled": "a418a6"
};
module.exports = exports;
